import React from 'react';
import { useParams } from 'react-router-dom';
import { StructuredContentPage } from '../components/content/StructuredContentPage';
import { NotFoundPage } from './NotFoundPage';
import { SEO } from '../components/seo/SEO';
import { useLanguage } from '../context/LanguageContext';
import { branchesDe } from '../data/branches-de';
import { branchesEn } from '../data/branches-en';

export const BranchContentPage: React.FC = () => {
  const { branchId } = useParams<{ branchId: string }>();
  const { language } = useLanguage();

  // Select the appropriate language content
  const branches = language === 'en' ? branchesEn : branchesDe;
  const entry = branchId ? branches[branchId] : undefined;

  // Translations for static elements
  const eyebrow = language === 'en' ? 'Industry' : 'Branche';

  if (!entry) {
    return <NotFoundPage />;
  }

  return (
    <>
      <SEO
        title={entry.title}
        description={entry.subtitle}
        canonical={`/industries/${branchId}`}
        schema={{
          '@context': 'https://schema.org',
          '@type': 'Industry',
          name: entry.title,
          description: entry.subtitle,
          provider: {
            '@type': 'Organization',
            name: 'Integrova AI',
          },
        }}
      />
      <StructuredContentPage
        eyebrow={eyebrow}
        title={entry.title}
        subtitle={entry.subtitle}
        heroImage={entry.heroImage}
        contextDesc={entry.contextDesc}
        operationalReality={entry.operationalReality}
        deliverables={entry.deliverables}
        capabilities={entry.capabilities}
        timeline={entry.timeline}
        riskCompliance={entry.riskCompliance}
        enablement={entry.enablement}
        nextSteps={entry.nextSteps}
      />
    </>
  );
};

